export default "__VITE_ASSET__DqSXtZFS__"